import React, { useCallback, useState } from 'react';

import { Collapser, ICollapserParams } from './Collapser';

interface ICollapserUncontrolledParams extends Omit<ICollapserParams, 'isOpen' | 'onToggle'> {
  /** Значение состояния по умолчанию */
  isDefaultOpened?: boolean;
}

/**
 * Неконтролируемый коллапсер контента
 */
export const CollapserUncontrolled = ({
  isDefaultOpened = false,
  children,
  ...props
}: ICollapserUncontrolledParams) => {
  const [isOpened, setIsOpened] = useState(isDefaultOpened);

  const handleToggle = useCallback(() => {
    setIsOpened(isOpened => !isOpened);
  }, []);

  return (
    <Collapser isOpen={isOpened} onToggle={handleToggle} {...props}>
      {children}
    </Collapser>
  );
};
